import { useCallback } from 'react'

import { RefetchQueriesFunction } from '@apollo/react-common'
import { ApolloQueryResult } from 'apollo-boost'

import { logger } from '@app/common/logger/logger'
import { useDetachDocumentFromLawyerMessageMutation } from '@app/queries/DetachDocumentFromLawyerMessage/DetachDocumentFromLawyerMessage.queries'

export type Args = {
  messageId: number
  refetchMessages: () => Promise<ApolloQueryResult<any>>
  refetchLetter: RefetchQueriesFunction
}

export const useDetachLawyerDocument = ({ messageId, refetchMessages, refetchLetter }: Args) => {
  const [detachLawyerDocumentMutation, { loading, error }] =
    useDetachDocumentFromLawyerMessageMutation()

  const detachDocument = useCallback(async (documentId) => {
    try {
      await detachLawyerDocumentMutation({
        refetchQueries: refetchLetter,
        variables: {
          messageId,
          documentId
        }
      })

      await refetchMessages()
    } catch (e) {
      logger.error(e)
    }
  }, [])

  return { detachDocument, detachDocumentLoading: loading, detachDocumentError: error }
}
